'use client'

import { cn } from '@buildbox/shared/utils'

interface AppVersionProps {
	/** Classes extras pro container — posicionamento varia por contexto (rodapé fixo no login, item no dropdown). */
	className?: string
}

/**
 * Exibe a versão do app (`NEXT_PUBLIC_APP_VERSION`, injetada em build-time pelo
 * next.config.js a partir do package.json). Quando o build roda dentro do
 * monorepo pnpm, anexa um "*" ao final (`NEXT_PUBLIC_IS_MONOREPO`).
 *
 * Retorna null se a versão não estiver disponível.
 */
export function AppVersion({ className }: Readonly<AppVersionProps>) {
	const version = process.env.NEXT_PUBLIC_APP_VERSION
	const isMonorepo = process.env.NEXT_PUBLIC_IS_MONOREPO === 'true'

	if (!version) return null

	return (
		<p className={cn('text-[11px] text-muted-foreground/50', className)}>
			v{version}
			{isMonorepo ? '*' : ''}
		</p>
	)
}
